var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CrmActivityCalendar',{attrs:{"client":_vm.client,"client-type":_vm.clientType,"user-contact-info":_vm.userContactInfo,"onload-open":_vm.onloadOpen}})}
var staticRenderFns = []

export { render, staticRenderFns }